<template>
    <div id="layout__application">
        <div v-if="initialized">
            <navigation-drawer
              v-if="!twilioChat"
              :roles="roles"
            />

            <application-toolbar />

            <v-main>

                <alerts v-if="salesDashboard" />
                <slot />

            </v-main>

            <snackbar-messages />
        </div>
    </div>
</template>

<script>
import Alerts from "@/components/Alerts";
import ApplicationToolbar from "@/components/ApplicationToolbar";
import NavigationDrawer from "@/components/NavigationDrawer";
import SnackbarMessages from "@/components/SnackbarMessages";
import router from "@/router";

export default {
  name: "ApplicationLayout",

  components: {
    Alerts,
    ApplicationToolbar,
    NavigationDrawer,
    SnackbarMessages
  },

  computed: {
    userIsAdmin() {
      return this.$store.getters.isAdmin;
    },

    userHasDocumentAccess() {
      return this.$store.getters.hasDocumentAccess;
    },

    initialized() {
      return this.$store.state.application.initialized;
    },

    roles() {
      return this.$store.state.user.roles;
    },

    twilioChat() {
      return this.$store.state.application.twilioChat;
    },

    salesDashboard() {
      return !this.$route.path.includes("/accounts-receivable");
    }
  },

  async created() {
    if (!this.$store.state.application.initCalled) {
      await this.$store.dispatch("initialize");
      if (this.roles.length === 1 && this.roles[0] === "call-center-ar-agent") {
        router.push({ name: "arDashboard" }).catch(() => {});
      } else if (this.roles[0] === "call-center-dashboard") {
        router.push({ name: "effectiveRateIndex" }).catch(() => {});
      } else {
        router.push({ name: "dashboard" }).catch(() => {});
      }
    }
  }
};
</script>
